export class EixoAtividade {
  id: number;
  nome: string;
  descricao: string;
  idInstituicao: number;
  usuarioAlteracao: number;
}
